export const ALERT_DATA = [];
